module.exports = __webpack_public_path__ + "assets/img/ac60-hu.svg";